import { Injectable } from '@angular/core';
import { CommercialFacilitySearch } from 'src/app/model/commercial-services/commercial-facility';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class CommercialFacilityTableService extends BaseTableService<CommercialFacilitySearch> {}
